exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".projects.card.small {\n  height: 213px !important; }\n\n.projects a {\n  color: #000000; }\n\n.card.card-content {\n  padding: 16px 24px; }\n\n.indicatorName {\n  line-height: 32px;\n  font-size: 0.8em; }\n\n.icon-position {\n  padding-top: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/epic-card/epic-card.component.scss
// module id = ../../../../../src/app/components/epic-card/epic-card.component.scss
// module chunks = main